import React, { useContext } from "react";
import { blogIsEnabled } from "../../utils/general";

// Components
import Copyright from "../Atoms/Copyright";
import Paragraph from "../Atoms/Paragraph";
import Link from "../Atoms/Link";
import HatchLogo from "../Atoms/HatchLogo";
import SocialIcons from "../Molecules/SocialIcons";
import AppStoreBadges from "../Molecules/AppStoreBadges";
import { LeadGenForm } from "../Molecules/LeadGenForm";
import { ImgixImage } from "../Utils/ImgixImage";
import { MobileOrTablet, Desktop } from "../Utils/ResponsiveComponent";
import { TrackingContext } from "../Utils/TrackingWrapper";

// Stylesheets
import "./Footer.scss";

// Constants
import {
  FOOTER_PRODUCT_LINKS,
  FOOTER_COMPANY_PAGE_LINKS,
  FOOTER_LEGAL_LINKS,
} from "../../utils/constants";

const LeadGenSection = () => (
  <div className="email_newsletter_signup">
    <Paragraph className="subheading">Come dream with us</Paragraph>
    <Paragraph className="body_secondary">
      Sign up to get sleep tips, exclusive offers, and more.
    </Paragraph>

    <LeadGenForm />
  </div>
);

const AppStoreBadgesSection = () => (
  <section className="app_store_badges_section">
    <Paragraph className="app_badges_subheading subheading">
      Get the Hatch sleep app
    </Paragraph>

    <AppStoreBadges />
  </section>
);

const Footer = () => {
  // GTM Track - Navigation
  const {
    trackingActions: { trackNavigation },
  } = useContext(TrackingContext);

  const onFooterNavClick = (clickText) => {
    trackNavigation({
      clickURL: document.location.pathname,
      clickText,
      location: "footer",
    });
  };

  return (
    <footer className="main_footer">
      <div className="container">
        <div className="main_links_section">
          <div className="company_links" data-testid="company_links">
            <Paragraph className="company_links_subheading subheading">
              Company
            </Paragraph>

            <ul className="links unstyled_list">
              {FOOTER_COMPANY_PAGE_LINKS.map(
                ({ displayName, linkProps }, idx) => {
                  if (!blogIsEnabled() && displayName === "Blog") {
                    return null;
                  }

                  return (
                    <li key={idx} className="link_wrapper">
                      <Link
                        className="body_secondary"
                        linkType="footer"
                        {...linkProps}
                        onClick={() => onFooterNavClick(displayName)}
                      >
                        {displayName}
                      </Link>
                    </li>
                  );
                }
              )}
            </ul>
          </div>

          <div className="product_links" data-testid="product_links">
            <Paragraph className="hb_shop_subheading subheading">
              Shop
            </Paragraph>
            <ul className="links unstyled_list">
              {FOOTER_PRODUCT_LINKS.map(({ displayName, linkProps }, idx) => (
                <li key={idx} className="link_wrapper">
                  <Link
                    className="body_secondary"
                    linkType="footer"
                    {...linkProps}
                    onClick={() => onFooterNavClick(displayName)}
                  >
                    {displayName}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="app_and_referral_links">
          <LeadGenSection />

          <MobileOrTablet>
            <AppStoreBadgesSection />
          </MobileOrTablet>

          <div className="careers_app_store_wrapper">
            <section className="careers_section">
              <div className="main_content">
                <Paragraph className="hb_shop_subheading subheading">
                  Come work with us
                </Paragraph>

                <ul className="links unstyled_list">
                  <li className="link_wrapper">
                    <Link
                      className="body_secondary"
                      linkType="footer"
                      href="/careers"
                      target="_self"
                      onClick={() => onFooterNavClick("Careers")}
                    >
                      Careers
                    </Link>
                  </li>
                </ul>
              </div>

              <ImgixImage
                className="great_place_work_badge"
                src="great-place-to-work-badge.png"
                sizes={{ desktop: "60px", tablet: "60px", default: "60px" }}
                alt="Great Place to Work Badge 2021"
              />
            </section>

            <Desktop>
              <AppStoreBadgesSection />
            </Desktop>
          </div>
        </div>

        <div className="social_links_logo_wrapper">
          <HatchLogo color="white" isLink={false} />

          <SocialIcons />
        </div>

        <div className="copyright_and_legal_links">
          <Copyright className="caption" />

          {FOOTER_LEGAL_LINKS.map(({ displayName, linkProps }, idx) => (
            <Link
              className="caption_secondary"
              key={idx}
              linkType="footer"
              {...linkProps}
              onClick={() => onFooterNavClick(displayName)}
            >
              {displayName}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
